import React from 'react';
import original from '../../images/ThiranXBot.jpg';
import wave from '../../images/thiranxbot-wave.png';
import './bot.css';

export default function BotMascot({ avatar = false, className = '', eager = false }) {
  return <img className={`txbot-mascot ${avatar ? 'txbot-avatar' : ''} ${className}`} src={avatar ? original : wave}
    alt={avatar ? '' : 'ThiranX Bot waving hello'} width={avatar ? 56 : 420} height={avatar ? 56 : 420}
    loading={eager ? 'eager' : 'lazy'} decoding="async" draggable="false" />;
}
